import { useMemo } from "react";

export default function useFirmNetworkOrAggregatorOptions() {
    const firmNetworkOrAggregatorOptions = useMemo(() => ([
        { name: "Acrisure", value: "Acrisure" },
        { name: "Affordable American", value: "Affordable American" },
        { name: "Agency Collective", value: "Agency Collective" },
        { name: "Agents Alliance Services", value: "Agents Alliance Services" },
        { name: "AIS Insurance", value: "AIS Insurance" },
        { name: "Alera", value: "Alera" },
        { name: "Allegiance", value: "Allegiance" },
        { name: "Alliant", value: "Alliant" },
        { name: "AmSuisse", value: "AmSuisse" },
        { name: "AON", value: "AON" },
        { name: "ARM Mid-America", value: "ARM Mid-America" },
        { name: "ARM of Mid America", value: "ARM of Mid America" },
        { name: "Arthur J Gallagher", value: "Arthur J Gallagher" },
        { name: "ASNOA", value: "ASNOA" },
        { name: "Assured Partners", value: "Assured Partners" },
        { name: "Atlas Insurance Brokers", value: "Atlas Insurance Brokers" },
        { name: "Amwins Direct Access Insurance Services (DAIS)", value: "Amwins Direct Access Insurance Services (DAIS)" },
        { name: "Bainswest Inc", value: "Bainswest Inc" },
        { name: "Baldwin Risk Partner", value: "Baldwin Risk Partner" },
        { name: "BGI Agency Network", value: "BGI Agency Network" },
        { name: "Brightway Ins", value: "Brightway Ins" },
        { name: "Broadstreet Partners", value: "Broadstreet Partners" },
        { name: "Brown & Brown", value: "Brown & Brown" },
        { name: "BXS", value: "BXS" },
        { name: "Canyon Lands Insurance", value: "Canyon Lands Insurance" },
        { name: "Chambers Bay", value: "Chambers Bay" },
        { name: "Charles Crane Agency", value: "Charles Crane Agency" },
        { name: "Choice Financial Group LLC", value: "Choice Financial Group LLC" },
        { name: "Cobbs Allen/CAC Specialty", value: "Cobbs Allen/CAC Specialty" },
        { name: "Combined Agents of America (CAA)", value: "Combined Agents of America (CAA)" },
        { name: "Comparion", value: "Comparion" },
        { name: "Comparion Insurance Agency", value: "Comparion Insurance Agency" },
        { name: "Confie", value: "Confie" },
        { name: "Consolidated Insurance Nation", value: "Consolidated Insurance Nation" },
        { name: "CoverWallet", value: "CoverWallet" },
        { name: "Cross Insurance", value: "Cross Insurance" },
        { name: "EPIC Insurance Brokers and Consultants", value: "EPIC Insurance Brokers and Consultants" },
        { name: "Estrella", value: "Estrella" },
        { name: "Farmers", value: "Farmers" },
        { name: "First Choice Ins", value: "First Choice Ins" },
        { name: "Foundation Risk", value: "Foundation Risk" },
        { name: "Freeway Ins Services", value: "Freeway Ins Services" },
        { name: "Global Green", value: "Global Green" },
        { name: "Goosehead Insurance", value: "Goosehead Insurance" },
        { name: "GreatFlorida Insurance", value: "GreatFlorida Insurance" },
        { name: "Heffernan Insurance Brokers", value: "Heffernan Insurance Brokers" },
        { name: "High Street Partners", value: "High Street Partners" },
        { name: "Highstreet Insurance Partners", value: "Highstreet Insurance Partners" },
        { name: "Higginbotham", value: "Higginbotham" },
        { name: "Hilb Group", value: "Hilb Group" },
        { name: "Horton Group", value: "Horton Group" },
        { name: "HUB International", value: "HUB International" },
        { name: "Hylant Group", value: "Hylant Group" },
        { name: "IMA Financial Group", value: "IMA Financial Group" },
        { name: "IMS", value: "IMS" },
        { name: "Independent Insurance Agents Of Texas (IIAT)", value: "Independent Insurance Agents Of Texas (IIAT)" },
        { name: "Insurance Agency Network (IAN)", value: "Insurance Agency Network (IAN)" },
        { name: "Insurance Offices of America (IOA)", value: "Insurance Offices of America (IOA)" },
        { name: "Insurance Services Of New England (ISNE)", value: "Insurance Services Of New England (ISNE)" },
        { name: "InsureOne Ins Services", value: "InsureOne Ins Services" },
        { name: "INSURICA Inc", value: "INSURICA Inc" },
        { name: "Integra Financial Group", value: "Integra Financial Group" },
        { name: "Inzone", value: "Inzone" },
        { name: "Ironpeak", value: "Ironpeak" },
        { name: "ISG United", value: "ISG United" },
        { name: "ISU", value: "ISU" },
        { name: "ISU Steadfast Insurance Agency Network", value: "ISU Steadfast Insurance Agency Network" },
        { name: "Keystone", value: "Keystone" },
        { name: "LA Insurance", value: "LA Insurance" },
        { name: "Lawley LLC", value: "Lawley LLC" },
        { name: "Leavitt Group", value: "Leavitt Group" },
        { name: "Lockton", value: "Lockton" },
        { name: "Marsh Berry Connect Platform", value: "Marsh Berry Connect Platform" },
        { name: "Marshberry FirstChoice Insurance", value: "Marshberry FirstChoice Insurance" },
        { name: "March McLennan Agency (MMA)", value: "March McLennan Agency (MMA)" },
        { name: "Marsh USA", value: "Marsh USA" },
        { name: "Midwest Insurance Agency Alliance (MIAA)", value: "Midwest Insurance Agency Alliance (MIAA)" },
        { name: "Mississippi Insurance Alliance (SIAA)", value: "Mississippi Insurance Alliance (SIAA)" },
        { name: "NAVSAV", value: "NAVSAV" },
        { name: "North American Insurance Alliance (NAII)", value: "North American Insurance Alliance (NAII)" },
        { name: "North Florida Agents Network (NFAN)", value: "North Florida Agents Network (NFAN)" },
        { name: "NFP", value: "NFP" },
        { name: "Oakbridge Insurance", value: "Oakbridge Insurance" },
        { name: "One Agents Alliance (OAA)", value: "One Agents Alliance (OAA)" },
        { name: "Other", value: "Other" },
        { name: "Patriot Growth", value: "Patriot Growth" },
        { name: "Pacific Crest Insurance", value: "Pacific Crest Insurance" },
        { name: "Pacific Interstate Insurance Brokers (PIIB)", value: "Pacific Interstate Insurance Brokers (PIIB)" },
        { name: "Pennsylvania Insurance Alliance (PIA)", value: "Pennsylvania Insurance Alliance (PIA)" },
        { name: "PIA Select", value: "PIA Select" },
        { name: "Polly", value: "Polly" },
        { name: "Premier Group Insurance", value: "Premier Group Insurance" },
        { name: "Relation Insurance Inc", value: "Relation Insurance Inc" },
        { name: "Renaissance Alliance Group", value: "Renaissance Alliance Group" },
        { name: "Rich and Cartmill", value: "Rich and Cartmill" },
        { name: "Robertson Ryan & Associates", value: "Robertson Ryan & Associates" },
        { name: "Rocky Mountain West Insurance (RMWI)", value: "Rocky Mountain West Insurance (RMWI)" },
        { name: "RSC Insurance Brokerage", value: "RSC Insurance Brokerage" },
        { name: "SBMP Insurance Group", value: "SBMP Insurance Group" },
        { name: "Scott Insurance", value: "Scott Insurance" },
        { name: "SIAA - Mountain Empire Agency Alliance", value: "SIAA - Mountain Empire Agency Alliance" },
        { name: "SIAA: The Agent Alliance", value: "SIAA: The Agent Alliance" },
        { name: "Simply IOA", value: "Simply IOA" },
        { name: "Southeastern Network Agencies (SNA)", value: "Southeastern Network Agencies (SNA)" },
        { name: "SSB Insurance", value: "SSB Insurance" },
        { name: "SSB Insurance Services", value: "SSB Insurance Services" },
        { name: "SterlingSeacrest Pritchard", value: "SterlingSeacrest Pritchard" },
        { name: "Sunstar Insurance Group", value: "Sunstar Insurance Group" },
        { name: "Superior Insurance Partners", value: "Superior Insurance Partners" },
        { name: "TAG Insurance Services", value: "TAG Insurance Services" },
        { name: "The Daniel and Henry Company", value: "The Daniel and Henry Company" },
        { name: "The Liberty Company Ins Brokers", value: "The Liberty Company Ins Brokers" },
        { name: "The Mahoney Group", value: "The Mahoney Group" },
        { name: "True North", value: "True North" },
        { name: "Trusted Insurance Alliance (TIA)", value: "Trusted Insurance Alliance (TIA)" },
        { name: "Trucordia", value: "Trucordia" },
        { name: "TWFG", value: "TWFG" },
        { name: "UniVista", value: "UniVista" },
        { name: "USI", value: "USI" },
        { name: "We Insure Group", value: "We Insure Group" },
        { name: "Westwood Insurance Agency", value: "Westwood Insurance Agency" },
        { name: "Willis", value: "Willis" },
        { name: "Woodruff Sawyer", value: "Woodruff Sawyer" },
        { name: "World Insurance Associates", value: "World Insurance Associates" }
    ]), []);

    return firmNetworkOrAggregatorOptions;
}